export default {
  "title": {
    "ranking": "Drivers ranking",
    "mainIndicators": "Principal indicators to calculate a behavioral grade of the period",
    "dailyBehaviorGrade": "Daily behavioral grade"
  },
  "help": {
    "mainIndicators": "Each one of these indicators are calculated according to the registered number of events on the trip, the length of it and the kilometers travelled in the selected period’s dates."
  },
  "labels": {
    "behaviorGrade": "Behavioral grade"
  },
  "graphTooltip": {
    "behaviorGrade": "Daily grade"
  },
  "table": {
    "ranking": "Ranking number",
    "driverName": "Driver’s name",
    "behaviorGrade": "Behavioral grade"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/behavior/detailBehavior.js